<div *ngIf="!isDescargaApp">
    <app-navbar></app-navbar>
</div>

<router-outlet></router-outlet>

<div *ngIf="!isDescargaApp">
    <app-footer></app-footer>
</div>

<ngx-scrolltop></ngx-scrolltop>
<!-- <app-sidebar></app-sidebar>
<app-righbar></app-righbar> -->